<template>
  <div class="container">
    <div class="shop" id="shop">
      <!-- 左边 -->
      <div class="menu-wrapper">
        <ul>
          <li
            class="menu-item"
            v-for="(goods, index) in foodList"
            :key="index"
            :class="{ active: index === currentIndex }"
            @click="clickList(index)"
            ref="menuList"
          >
            <span>{{ goods.name }}</span>
          </li>
        </ul>
      </div>
      <!-- 右边 -->
      <div class="shop-wrapper">
        <ul ref="itemList" class="food-item">
          <li
            class="shops-li food-list"
            v-for="(good, index1) in foodList"
            :key="index1"
          >
            <div class="shops-title">
              <div class="title">{{ good.name }}</div>
            </div>
            <ul class="item">
              <li v-for="(item, ind) in good.food" :key="ind">
                <div class="foodPrices">
                  <div class="info">
                    <img :src="Config.baseURL + item.picture" alt="" />
                    <div class="good">{{ item.name }}</div>
                  </div>

                  <van-checkbox
                    ref="item_status"
                    v-model="item.checked"
                    @click="change(item.checked)"
                  />
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="foot">
      <div>
        <div class="num">已选择{{ num }}个商品</div>
        <van-button type="info" @click="submit">确认添加</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
import Config from "../../../config";
export default {
  data() {
    return {
      checked: false,
      afterScroll: false,
      oldHeight: 0,
      clientHeightY: 400,
      ortherHeight: 0,
      clientWidth: 0,
      searchgoods: [],
      scrollY: 0, //右侧列表滑动的y轴坐标
      rightLiTops: [], //所有分类头部位置
      num: 0,
      foodList: [],
      industry: "",
      category: "",
      checkedArr:[]
    };
  },
  computed: {
    //动态绑定class类名
	currentIndex(index) {
      const { scrollY, rightLiTops } = this;
      let _index = rightLiTops.findIndex((tops, index) => {
        return scrollY >= tops && scrollY < rightLiTops[index + 1];
      });
      if (_index != -1) {
        this._initLeftScroll(_index);
      }
      return _index
    },
  },
  created() {
    (this.foodList = []), (this.industry = this.$route.query.industry);
    this.category = this.$route.query.category;
    this.getFoodList();
  },
  mounted() {
    // 为了滑动区域高度适应所有机型
    let height = document.body.clientHeight;
    let width = document.body.clientWidth;
    this.clientWidth = width;
    this.clientHeightY = height - (width / 750) * 450;
    this.oldHeight = this.clientHeightY;
    this.ortherHeight = this.clientHeightY + (this.clientWidth / 750) * 220;
    console.log(this.clientHeightY);
  },
  methods: {
    getFoodList() {
      this.$http
        .post("/wechat/api.food_library/getFoodList", {
          industry: this.industry,
          category: this.category,
        })
        .then((response) => {
          if (response && response.body.code == 200) {
            this.foodList = response.body.data;
            //监听数据
            this.$nextTick(() => {
              //左右两边滚动
              this._initBScroll();
              //右边列表高度
              this._initRightHeight();
            });
          }
        });
    },
    // 选择菜品
    change(v) {
      console.log(v);
      var checked_num = 0;
      this.checkedArr=[]
      if (v) {
        this.foodList.map((item) => {
          item.food.map((i) => {
            if (i.checked) {
              this.checkedArr.push(i.id)
              checked_num++;
              console.log(checked_num);
              console.log(i.name);
              this.num = checked_num;
            }
          });
        });
      } else {
        this.num--;
      }
    },
    _initBScroll() {
      //左边滚动
      this.leftBscroll = new BScroll(".menu-wrapper", { click: true });

      //右边滚动
      this.rightBscroll = new BScroll(".shop-wrapper", {
        probeType: 3,
        click: true,
        bounce: false,
      });
      //监听右边滚动事件
      this.rightBscroll.on("scroll", (pos) => {
        this.scrollY = Math.abs(pos.y);
        if (this.scrollY >= 30) {
          this.afterScroll = true;
          this.clientHeightY = this.ortherHeight;
        } else if (this.scrollY >= 3 || this.scrollY === 0) {
          this.afterScroll = false;
          this.clientHeightY = this.oldHeight;
        }
      });
    },

    //求出右边列表的高度
    _initRightHeight() {
      let itemArray = [];
      let top = 0;
      itemArray.push(top);
      let allList = this.$refs.itemList.getElementsByClassName("shops-li");
      Array.prototype.slice.call(allList).forEach((li) => {
        top += li.clientHeight;
        console.log(top);
        itemArray.push(top);
        console.log(itemArray);
      });
      this.rightLiTops = itemArray;
      console.log("rightLiTops", this.rightLiTops);
    },
    //点击左边实现滚动
    clickList(index) {
      this.scrollY = this.rightLiTops[index];
      console.log("scrollY", this.scrollY);
      this.rightBscroll.scrollTo(0, -this.scrollY, 600);
    },
    //左右联调
    _initLeftScroll(index) {
      let menu = this.$refs.menuList;
      let el = menu[index];
      this.leftBscroll.scrollToElement(el, 200, 0, true);
    },
    submit() {
      this.$http
        .post("/wechat/api.food_library/addFoods", {
          id:this.checkedArr
        })
        .then((response) => {
          if (response && response.body.code == 200) {
            this.$router.push("/FoodManagement");
          }
        });
    },
  },
};
</script>


<style scoped  lang="less">
// 左侧菜品
.shop {
  display: flex;
  z-index: 10;
  height: 92vh;
  padding-bottom: 1.5rem;
  border-top: 1px solid #f0f0f0;
}
.menu-wrapper {
  width: 26%;
  height: 100%;
  overflow: hidden;
  transition: all 0.5s;
  font-size: 0.4rem;
}
.menu-wrapper ul li {
  text-align: center;
  padding: 0.4rem 0;
}
// 左侧菜品点击时的颜色
.active {
  background: #ffffff;
}
.shop-wrapper {
  width: 74%;
  height: 100%;
  overflow: hidden;
  background: #ffffff;
  transition: all 0.5s;
}
.shops-li {
  width: 100%;
}
.shops-title {
  padding: 0.3rem;
}
.foodPrices {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.4rem;
  padding: 0 0.2rem;
}
.foodPrices .info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.foodPrices .info img {
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 0.4rem;
  border-radius: 0.1rem;
}

.afterScroll {
  opacity: 0;
  transition: all 0.5s;
  height: 0;
}
// 右侧菜品标题
.shops-title .title {
  font-size: 0.5rem;
}
.shops-li .item li {
  padding: 0.2rem 0;
}

.foot {
  width: 100%;
  height: 1.5rem;
  position: fixed;
  bottom: 0;
  background-color: #ffffff;
  border-top: 1px solid #f0f0f0;
}
.foot > div {
  width: 94%;
  height: 1.5rem;
  padding: 0 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.4rem;
}
.current {
  background-color: #fecf02;
}

::-webkit-scrollbar {
  width: 0;

  height: 0;

  color: transparent;
}
</style>